<div style="max-width: 718px; padding:-24px !important;">
    <mat-toolbar matDialogTitle class="m-0 mb-24" set-color [backgroundColor]="subjectType.color">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title">Link {{subjectType.name}}</span>
            <button mat-icon-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon set-color [backgroundColor]="subjectType.color">close</mat-icon>
            </button>
        </div>
    </mat-toolbar>    
    <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step [completed]="linkSubject">
            <ng-template matStepLabel>Select {{subjectType.name}}</ng-template>

            <!-- CONTENT -->
            <div class="content-card mat-white-bg wizard-content p-12" fxLayout="column">
                <!-- SEARCH AND ADD-->
                <div class="search-input-wrapper ml-8 m-sm-0 pb-8" fxFlex="0 0 auto" fxLayout="row"
                    fxLayoutAlign="start center">
                    <label for="search" class="mr-8">
                        <mat-icon class="secondary-text">search</mat-icon>
                    </label>
                    <mat-form-field floatPlaceholder="never" style="max-width:525px!important;min-width:525px!important;">
                        <!-- fxFlex="1 0 auto" style="max-width:525px!important" -->
                        <input #search matInput placeholder="Search">
                    </mat-form-field>

                    <div>
                        <button mat-fab class="add-button mat-warn ml-32" (click)="addSubject()"
                            attr.aria-label="Add {{subjectType.name}}" matTooltip="Add {{subjectType.name}}" *fuseIfOnDom>
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
                <!-- / SEARCH AND ADD-->

                <div class="w-100-p" style="flex: 1 1 auto;box-sizing: border-box;height: 100px;">
                    <data-grid style="max-height: 100%;" #list [rows]="subjects" [columns]="columns"
                        [allowCustomisation]="false" [keyProperty]="'id'" [showButtons]="false" [showPager]="false"
                        [showRowCount]="false" [showSearch]="false" (onSelectionChanged)="onSelectSubject($event)">
                    </data-grid>
                </div>
            </div>
            <!-- / CONTENT -->
            <div class="pt-8">
                <button mat-raised-button matStepperNext class="mat-accent" (click)="setupRelationships()"
                    [disabled]="!linkSubject">NEXT</button>
            </div>
        </mat-step>
        <mat-step [stepControl]="relationshipFormGroup">
            <form [formGroup]="relationshipFormGroup">
                <ng-template matStepLabel>Specify relationship</ng-template>

                <div class="content-card mat-white-bg wizard-content p-32" fxLayout="column">
                    <mat-form-field>
                        <mat-select class="form-control" placeholder="Relationship" formControlName="linkRelationship"
                            required>
                            <mat-option *ngFor="let item of relationships" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <validation-errors [control]="relationshipFormGroup?.get('linkRelationship')"></validation-errors>

                    <mat-checkbox class="pt-12" formControlName="addToDashboard" id="addToDashboard">Add to dashboard
                    </mat-checkbox>
                </div>

                <div>
                    <button mat-raised-button matStepperPrevious class="mat-accent mr-4">BACK</button>
                    <button mat-raised-button matStepperNext class="mat-accent ml-4"
                        [disabled]="!relationshipFormGroup.get('linkRelationship').value">NEXT</button>
                </div>
            </form>

        </mat-step>
        <mat-step [stepControl]="existingRelationshipsFormGroup" [optional]=true>
            <form [formGroup]="existingRelationshipsFormGroup">
                <ng-template matStepLabel>Add Other relationships</ng-template>
                <div fxLayout="column" fxLayoutAlign="stretch start">
                    <div class="content-card mat-white-bg wizard-content p-32" fxFlex="0 1 auto" fxLayout="column"
                        fxLayoutAlign="start center">
                        <div *ngIf="subjectsLinkedToLinkSubject.length!=0" fxLayout="column"
                            fxLayoutAlign="start start">
                            <div class="pt-12">This {{parentSubjectType.name}} has existing linked subjects.</div>
                            <div class="pt-4 pb-24">To link any of these subjects directly to {{subjectType.name}}
                                {{linkSubject.summary}} specify a relationship for the link.</div>
                            <div class="existinglinks">
                                <div formArrayName="existingLinks"
                                    *ngFor="let existingLink of existingRelationshipsFormGroup.get('existingLinks').controls; let i=index;"
                                    fxLayout="row" fxLayoutAlign="start center">
                                    <div [formGroupName]="i">
                                        <div class="link" fxLayout="row" fxLayoutAlign="start center">
                                            <div *ngIf="subjectsLinkedToLinkSubject[i]?.subjectType" class="avatar"
                                                [style.background-color]="subjectsLinkedToLinkSubject[i].subjectType?.color">
                                                {{subjectsLinkedToLinkSubject[i].subjectType?.name[0]}}</div>
                                            <div>
                                                <div class="h3" style='width:300px;'>
                                                    {{subjectsLinkedToLinkSubject[i].linkedSubject.summary}}</div>
                                                <div>
                                                    <span
                                                        class="secondary-text">{{subjectsLinkedToLinkSubject[i].relationship.name}}</span>
                                                </div>
                                            </div>
                                            <mat-form-field class="pr-24" style="min-width: 300px;">
                                                <mat-select class="form-control" placeholder="Relationship"
                                                    name="linkRelationship" formControlName="directRelationshipId">
                                                    <mat-option>-- Do not link --</mat-option>
                                                    <mat-option
                                                        *ngFor="let item of subjectsLinkedToLinkSubject[i].relationships"
                                                        [value]="item.id">
                                                        {{item.name}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <!-- <button mat-icon-button class="pr-12" aria-label="Clear relationship" (click)="existingRelationshipsFormGroup.controls.existingLinks.controls[i].controls.directRelationshipId.value=0;" matTooltip="Clear relationship">
                                        <mat-icon style="color:red;">clear</mat-icon>
                                    </button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="subjectsLinkedToLinkSubject.length==0" flex fxLayout="column"
                            fxLayoutAlign="center center">
                            There are no existing links for the {{parentSubjectType.name}}
                        </div>
                    </div>
                    <div fxFlex="0 0 auto">
                        <button mat-raised-button matStepperPrevious class="mat-accent mr-4">BACK</button>
                        <button mat-raised-button matStepperNext class="mat-accent ml-4">NEXT</button>
                    </div>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Done</ng-template>
            <div class="content-card mat-white-bg wizard-content p-32" fxLayout="column" fxLayoutAlign="center center">
                Click the save button to create the link(s).
            </div>
            <div>
                <button mat-raised-button matStepperPrevious class="mat-accent mr-4">BACK</button>
                <button mat-raised-button (click)="saveLinks()" class="mat-accent ml-4" aria-label="SAVE"
                    [disabled]="btnSaveDisabled">SAVE</button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>

    <!-- <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button mat-raised-button
                    [type]="submit"
                    [disabled]="!hasChanged"
                    [mat-dialog-close]="1"
                    (click)="save()"
                    class="save-button mat-accent"
                    aria-label="SAVE">
                SAVE
            </button>
        </div>
    </div> -->
</div>